<template>
    <div class="content-wrapper page">
        <HeroCaro :Title=Title :Tagline=Tagline />

        <div class="intro-content-wrapper">
        <div class="line" ref="line"></div>

            <div class="section-wrapper graphic-next"> 
                <div class="section-block">
                    <div class="text-wrapper">
                        <h6 class="section-header">Take a dive</h6>
                        <p>Theories often start from a place of commonly accepted thought, but verge. Through rabbit holes, investigation,
                        and exploration our understandings can take on different interpretations.
                        <br>
                        <br>
                        Here are a few views of the earth side by side; some of which are considered more extreme than others. 
                        However, through comparison, some of the "cracks" within the known can allow us to see these bridges.
                        </p>
                    </div>
                </div>
            </div>
            <!-- <div class="section-wrapper"> 
                <div class="section-block">
                    <div class="text-wrapper">
                        <h6 class="section-header">Rabbit holes?</h6>
                        <p>It is described as, "a complexly bizarre or difficult state or situation conceived of as a hole into which one falls or descends".
                            One in which the pursuit of something (such as an answer or solution) leads to other questions, problems, or pursuits.
                        </p>
                    </div>
                </div>
            </div> -->
        
            <!-- <div class="section-wrapper"> 
                <div class="section-block">
                    <div class="text-wrapper">
                        <h6 class="section-header">Falling into Conclusions</h6>
                        <p>These trips can lead to giving “causes and motives to events that are more rationally seen as accidents…[in order to] bring the disturbing vagaries of reality under control."</p>
                    </div>
                </div>
            </div> -->

            <!-- <div class="section-wrapper graphic-next"> 
                <div class="section-block">
                    <div class="text-wrapper">
                        <h6 class="section-header">Why?</h6>
                        <p>Lacking control is an unsettling and aversive state, 
                        activating the amygdala, which indicates a fear 
                        response. It is not surprising, then, that individuals 
                        actively try to reestablish control when it disappears 
                        or is taken away.</p>
                    </div>
                </div>
            </div> -->

            <!-- <div class="section-block">
                <div class="graphic-block">
                    <div class="ink-blot-wrapper">
                        <img src="../assets/graphics/ink-blot.svg" alt="">
                    </div>
                </div>
            </div> -->

            <!-- <div class="section-wrapper graphic-prev"> 
                <div class="section-block">
                    <div class="text-wrapper">
                        <h6 class="section-header">Take a dive</h6>
                        <p>Conspiracy theories often start from a place of commonly accepted thought, but verge. Through rabbit holes
                        many of these facts can take on different interpretations.
                        <br>
                        <br>
                        Here are a few understandings of the earth side by side; 
                        some which are more extreme than others. 
                        Through comparison, some of the "cracks"
                        within the known can allow us to see these bridges.
                        </p>
                    </div>
                </div>
            </div> -->

            <h6 class="button-header">"The Earth is..."</h6>
            <div class="button-wrapper">
                <div class="button round" ref="beginButton">"Round"</div>
                <div class="button flat" ref="flatButton">"Flat"</div>
                <div class="button hollow" ref="hollowButton">"Hollow"</div>
            </div>
        </div>

    </div>
</template>

<script>
import HeroCaro from '../components/HeroCaro.vue';
export default {
    name: 'Intro',
    components: {
        HeroCaro
    },
    data() {
        return {
            Title: 'aperçus',
            Tagline: 'Glimpses of the earth'
        }
    },
    methods: {
        round() {
            // console.log("Clicked!");
            // this.$emit('changeComponent', 'Simulation');
            this.$emit('introChangeComponent', 1);
        },
        flat(){
            this.$emit('introChangeComponent', 2);
        },
        hollow(){
            this.$emit('introChangeComponent', 3);
        }
    },
    created() {
    },
    mounted() {
        window.scrollTo(0, 0);
        this.$refs.beginButton.addEventListener("click", this.round);
        this.$refs.flatButton.addEventListener("click", this.flat);
        this.$refs.hollowButton.addEventListener("click", this.hollow);
    }
}
</script>

<style scoped>
    .intro-wrapper {
        margin-top: 62.5vh;
        height: 90vh;
        width: 100%;
        position: relative;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        /* background-color: green; */
    }

    .intro-content-wrapper {
        /* height: 500vh; */
        width: 100%;
        /* background-color: red; */
        position: relative;
        padding-top: 20vh;
        margin-top: 45vh;
    }

    .content-wrapper {
        /* height: 500vh; */
        width: 100%;
        /* background-color: red; */
        position: relative;
        /* padding-top: 20vh; */
        margin-top: 50px;
        width: calc(100% - 160px);
        margin: auto;
        padding-left: 260px;
        padding-right: 119px;
        box-sizing: border-box;
    }

    .line {
        position: absolute;
        right: 12vw;
        top: 0;
        height: calc(100% + 20vh);
        width: 1px;
        background-color: #212121;
        z-index: 9;
    }

    .section-wrapper {
        width: 100%;
        /* min-height: 70vh; */
        padding-top: 200px;
        padding-bottom: 200px;
        user-select: none;
    }

    .graphic-next {
        padding-bottom: 150px !important;
    }

    .graphic-prev {
        padding-top: 150px !important;
    }

    .pull {
        padding-top: 100px !important;
    }

    .line + .section-wrapper {
        padding-top: 0px !important;
    }

    .section-block {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        /* background-color: pink; */
        position: relative;
        /* height: 500px; */
    }

    .graphic-block {
        /* height: 300px; */
        height: 560px;
        width: 100%;
        /* background-color: red; */
        position: relative;
    }

    .ink-blot-wrapper {
        width: 400px;
        height: 560px;
        /* background-color: yellow; */
        position: absolute;
        right: calc(12vw - 199px); 
    }

    .tectonic {
        height: 400px !important;
        /* width: calc(100% - 20vw) !important; */
    }

    .tectonic img {
        height: 100%;
    }

    .mag-field-wrapper {
        position: absolute;
        right: calc(12vw - 250px); 
        /* height: 300px; */
        /* width: 500px; */
    }

    .sphere-wrapper {
        position: absolute;
        right: calc(12vw - 150px); 
        height: 300px;
        width: 300px;
    }

    .header-dot {
        position: absolute;
        right: calc(12vw - 30px);
        top: -20px;
        height: 60px;
        width: 60px;
        border-radius: 50%;
        background-color: #2D7BE5;
        border: 1px solid #212121;
        box-sizing: border-box;
        z-index: 9;
    }

    h6 {
        font-family: odisseia, sans-serif;
        text-transform: uppercase;
        font-weight: 900;
        font-size: 20px;
        margin: 0px 0px 7px 0px;
        width: calc(100% - 30vw);
    }

    .section-header {
        font-size: 36px;
        color: #212121;
    }

    p {
        font-family: roboto, sans-serif;
        font-size: 20px;
        line-height: 32px;
        width: calc(100% - 30vw);
        margin: 0;
        letter-spacing: .5px;
    }

    /* .button-wrapper {
        bottom: calc(0px - 40vh - 25px);
    } */

    .pull-quote {
        width: calc(100% - 30vw);
        font-family: odisseia, sans-serif;
        font-weight: 900;
        font-size: 51px;
        line-height: 71px;
        color: #2D7BE5;
        margin: 0;
        text-transform: uppercase;
    }

    .image-wrapper {
        position: relative;
        left: -220px;
        height: 92vh;
        width: calc(100% + 220px + 79px);
        /* background: yellow; */
        position: relative;
        overflow: hidden;
    }

    .image-text {
        font-family: odisseia, sans-serif;
        font-size: 10px;
        color: #F0F4F8;
        text-transform: uppercase;
        /* color: red; */
        margin: 0;
        opacity: .80;
        transform: rotate(-90deg) translateY(-240%) translateX(-50%);
        transform-origin: middle;
        position: absolute;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        white-space: nowrap;
        align-items: flex-end;
        top: 0;
        left: 0;
        user-select: none;
    }

    .image-1 {
        background-image: url("../assets/images/green-mountain-boris-baldinger.jpg");
        background-size: cover;
        background-position: top center;
    }

    .image-2 {
        background-image: url("../assets/images/waterfall-joao-barbosa.jpg");
        background-size: cover;
        background-position: top center;
    }

    .image-3 {
        background-image: url("../assets/images/lava-in-ocean-buzz-andersen.jpg");
        background-size: cover;
        background-position: top center;
    }

    .image-4 {
        background-image: url("../assets/images/earth-from-space-richard-gatley.jpg");
        background-size: cover;
        background-position: top center;
    }

    .layers-section {
        /* background-color: teal; */
        position: relative;
    }

    .layers-graphic-wrapper {
        /* height: calc(100% - 550px); */
        width: 300px;
        /* position: sticky; */
        position: absolute;
        top: 200px;
        box-sizing: border-box;
        /* padding: 200px 0px; */
        right: calc(12vw - 150px); 
        /* right: 12vw; */
        /* background-color: red; */
        z-index: 9;

    }

    .layers-info-text {
        font-family: odisseia, sans-serif;
        font-size: 10px;
        /* color: #F0F4F8; */
        text-transform: uppercase;
        /* color: red; */
        /* margin: 0; */
        /* opacity: .80; */
        /* transform-origin: middle; */
        position: absolute;
        white-space: nowrap;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        user-select: none;
        width: 120px;
        opacity: 0;
        text-align: center;
        background-color: #F0F4F8;
        color: #212121;
        transition: opacity .3s ease-in-out;
    }

    .layer-graphic {
        height: 300px;
        width: 300px;
        /* background-color: black; */
        /* border-radius: 50%; */
        top: calc(50% - 150px);
        position: sticky;
        /* background-image: url("../assets/graphics/codex_1/full-layers.svg"); */
    }

    .layers-wrapper {
        /* background-color: green; */
        height: 100%;
        width: 100%;
        position: relative;
    }

    .layers-wrapper img {
        opacity: 0;
        height: 100%;
        width: 100%;
        position: absolute;
        transition: opacity .3s ease-in-out;
    }

    .active {
        opacity: 1;
    }

    .button:hover.round {
        /* box-shadow: 0px 0px 0px 5px #212121; */
        background-color: #2D7BE5;
        cursor: pointer;
    }

    .button:hover.flat {
        /* box-shadow: 0px 0px 0px 5px #212121; */
        background-color: #459300;
        cursor: pointer;
    }

    .button:hover.hollow {
        /* box-shadow: 0px 0px 0px 5px #212121; */
        background-color: #D2841A;
        cursor: pointer;
    }

</style>